import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FarmTypeForm from '../../../components/forms/FarmTypeForm';
import { useFarmTypeApi } from '../../../hooks/useFarmTypeApi';
import { useNavigate } from 'react-router-dom';
import { FarmTypeDTO } from '../../../services/apiClient';

const FarmTypeCreate: React.FC = () => {
  const { create, isLoading } = useFarmTypeApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Farm Types', href: '/admin/farmtypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FarmTypeDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/farmtypes');
    } catch (error) {
      console.error('Error creating FarmType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/farmtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.FarmType.Edit"
    >
      <FarmTypeForm
        initialValues={{} as FarmTypeDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/farmtypes')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default FarmTypeCreate;
